module.exports = __webpack_public_path__ + "img/goals-bomb.48031fb7.svg";